import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import React from "react";
import { Button, Modal } from "react-bootstrap";

import FASvgIcon from "../FASvgIcon";
import { ButtonSpinner } from "../placeholders";

type Props = {
  showModal: boolean;
  onYesBtnClick: () => void;
  onNoBtnClick: () => void;
  title: string;
  message: JSX.Element | string;
  onYesBtnText?: string;
  onNoBtnText?: string;
  onYesBtnVariant?: string;
  isProcessing?: boolean;
  icon?: IconProp;
  iconColorClass?: string;
};

const ConfirmationModal: React.FC<Props> = (props: Props) => {
  const {
    showModal,
    title,
    message,
    onYesBtnClick,
    onYesBtnText = "Delete",
    onNoBtnClick,
    onNoBtnText = "Cancel",
    onYesBtnVariant = "danger",
    isProcessing = false,
    iconColorClass = "text-primary",
    icon = faCircleCheck
  } = props;

  return (
    <Modal show={showModal} centered backdrop="static" className="confirm-modal">
      <Modal.Body className="text-center">
        <div className={classNames("icon-wrap", iconColorClass)}>
          <FASvgIcon icon={icon} />
        </div>
        <h1 className="fw-bold">{title}</h1>
        <div className="modal-text">{message}</div>
      </Modal.Body>
      <Modal.Footer className="modal-btns-wrap">
        <Button
          variant="outline-greyDark"
          size="lg"
          className="btn-w-150"
          onClick={onNoBtnClick}
          disabled={isProcessing}
        >
          {onNoBtnText}
        </Button>
        <Button
          variant={onYesBtnVariant}
          size="lg"
          className="btn-w-150"
          onClick={onYesBtnClick}
          disabled={isProcessing}
        >
          {!isProcessing ? onYesBtnText : <ButtonSpinner />}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
